export const INCOME_HEADER_HEIGHT = 70;
export const MONTH_BOX_SHADOW =
  '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
export const MONTH_RIGHT_PADDING = 5;
